import React from 'react';
import Styled from './styles';

const Content = ({ children }) => <Styled.Content>{children}</Styled.Content>;

export default Content;
